require.register("documenteditor/controllers/fieldEntryQuellenCtrl", function(exports, require, module){
  $0
  
});

